import { css } from "lit";

export const styles = css`
  :host {
    display: inline-flex;
  }

  .live-badge {
    display: flex;
    align-items: center;
    gap: 6px;
    padding: var(--live-badge-padding, 4px 12px);
    background: var(--sds-color-background-danger-default);
    color: white;
    border-radius: var(--sds-size-radius-full);
    font: var(--sds-typography-weight-semibold) var(--sds-typography-scale-01) var(--sds-typography-family-body);
    text-transform: uppercase;
    letter-spacing: 0.5px;
  }

  .live-badge.paused {
    background: var(--sds-color-background-warning-default);
  }

  .live-badge.paused #l1 {
    d: path("M6,6 L6,18");
  }

  .live-badge.paused #l2 {
    d: path("M12,14 L12,18");
  }

  .live-badge.paused #l3 {
    d: path("M18,8 L18,18");
  }

  .live-badge.preview {
    background: var(--sds-color-background-default-secondary);
    color: var(--sds-color-text-default-secondary);
  }

  .live-indicator {
    display: var(--live-badge-indicator-display, block);
    width: 8px;
    height: 8px;
    background: white;
    border-radius: 50%;
    animation: pulse 1.5s infinite;
  }

  .live-badge.paused .live-indicator {
    animation: none;
  }

  .live-badge.preview .live-indicator {
    background: var(--sds-color-text-default-secondary);
    animation: none;
  }

  @keyframes pulse {
    0%,
    100% {
      opacity: 1;
    }
    50% {
      opacity: 0.5;
    }
  }

  .live-badge.live #l1 {
    animation: bar1 1.2s ease-in-out infinite;
  }

  .live-badge.live #l2 {
    animation: bar2 1.2s ease-in-out -0.4s infinite;
  }

  .live-badge.live #l3 {
    animation: bar3 1.2s ease-in-out -0.8s infinite;
  }

  @keyframes bar1 {
    0%,
    100% {
      d: path("M6,14 L6,18");
    }
    50% {
      d: path("M6,4 L6,18");
    }
  }

  @keyframes bar2 {
    0%,
    100% {
      d: path("M12,12 L12,18");
    }
    50% {
      d: path("M12,6 L12,18");
    }
  }

  @keyframes bar3 {
    0%,
    100% {
      d: path("M18,14 L18,18");
    }
    50% {
      d: path("M18,4 L18,18");
    }
  }
`;
